import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { NavBarComponent } from "./pages/nav-bar/nav-bar.component";
import { LoginGuard } from "./shared/guards/login.guard";
import { PageNotPermissionComponent } from "./pages/page-not-permission/page-not-permission.component";

const routes: Routes = [
  { path: "", pathMatch: "full", redirectTo: "/home" },
  // { path: 'login', loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule) },
  {
    path: "",
    component: NavBarComponent,
    canActivate: [LoginGuard],
    children: [
      { path: 'home', loadChildren: () => import('./pages/default-page/default-page.module').then(m => m.DefaultPageModule) },
      { path: 'blood', loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule) },
      { path: 'medicalreport', loadChildren: () => import('./pages/medicalreport/medicalreport.module').then(m => m.MedicalreportModule) },
      { path: 'food', loadChildren: () => import('./pages/food/food.module').then(m => m.FoodModule) },
      { path: 'drug', loadChildren: () => import('./pages/drug/drug.module').then(m => m.DrugModule) },
      { path: 'sport', loadChildren: () => import('./pages/sport/sport.module').then(m => m.SportModule) },
      { path: "change-passwd", loadChildren: () => import("./pages/management/change-passwd/change-passwd.module").then((m) => m.ChangePasswdModule) },
      { path: "users", loadChildren: () => import("./pages/management/users/users.module").then((m) => m.UsersModule) },
      { path: "user", loadChildren: () => import("./pages/permissions/user/user.module").then((m) => m.UserModule) },
      { path: "authority", loadChildren: () => import("./pages/permissions/authority/authority.module").then((m) => m.AuthorityModule) },
      { path: "role", loadChildren: () => import("./pages/permissions/role/role.module").then((m) => m.UserModule) },
      { path: "department", loadChildren: () => import("./pages/organizational/department/department.module").then((m) => m.DepartmentModule) },
      { path: "organization", loadChildren: () => import("./pages/organizational/organization/organization.module").then((m) => m.OrganizationModule) },
    ]
  },
  { path: "**", component: PageNotPermissionComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: "reload" })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
